import { iconButtonClasses, Modal, Tooltip } from "@mui/material";
import { Box } from "@mui/system";
import React, { useEffect, useRef, useState } from "react";
import { useForm, useFormContext } from "react-hook-form";
import CancelPresentationIconButton from "../../../common/components/Buttons/CancelPresentationIconButton";
import CommonButton from "../../../common/components/Buttons/CommonButton";
import CreateableSelect from "../../../common/components/FormFields/CreateableSelect";
import DatePickerField from "../../../common/components/FormFields/DatePickerField";
import DropdownField from "../../../common/components/FormFields/DropdownField";
import InputField from "../../../common/components/FormFields/InputField";
import RadioField from "../../../common/components/FormFields/RadioField";
import { format } from "date-fns";
import CommonTransactionTable from "../../../common/components/CommonTable/CommonTransactionTable";
import ConfirmationModal from "../../../common/components/ConfirmationModal";
import SearchDropdown from "../../../common/components/FormFields/searchDropdown";
import {
  errdeleteAlert,
  successAlert,
  warningAlert,
} from "../../../common/components/Toasts/CustomToasts";
import AltDrugTable from "../../../common/components/AlternateTable";
import Medicationtable from "../../../common/components/MedicationTable";
import {
  deleteMedication,
  getFrequency,
  getFrequencyChips,
  getGenaricTable,
  getInstruction,
  getInstructionChips,
  getPastMedication,
  getRoute,
  getRouteChips,
  prescription,
} from "../services/EMRServices/emrServices";
import {
  DeleteIcon,
  EditIcon,
  PastHistoryMedication,
} from "./EmrCommonAsset/Asset";
import { useEMRGeneralContext } from "../newGeneralEmr/EMRContextGeneral";
import CheckBoxField from "../../../common/components/FormFields/CheckBoxField";
import DrugTaperingModal from "./DrugTaperingModal";
const typeData = [
  {
    id: "Brand",
    label: "Brand",
    value: "Brand",
  },
  {
    id: "Generic",
    label: "Generic",
    value: "Generic",
  },
];

export default function MedicationModal(props) {
  const {
    medicationData,
    setMedicationData,
    dataMedication,
    setDataMedication,
    openMedicationModal,
    setOpenMedicationModal,
    actions,
    setActions,
    weight,
    height,
    patientData,
    drugTaperingData,
    setDrugTaperingData,
  } = props;
  const [drugSearchString, setDrugSearchString] = useState("");

  const [frequencyOptions, setFrequencyOptions] = useState();
  const [frequency, setFrequency] = useState([]);
  const [frequncyChipsList, setFrequncyChipsList] = useState([]);
  const [chipsCount, setChipsCount] = useState(5);
  const [chipsInstruction, setChipsInstruction] = useState(4);
  const [selectedFrequncyChips, setSelectedFrequncyChips] = useState([]);
  const [selectedInstructionChips, setSelectedInstructionChips] = useState([]);
  const [instructionList, setInstructionList] = useState();
  const [instructionChipsList, setInstructionChipsList] = useState([]);
  const [selectedDuration, setSelectedDuration] = useState([]);
  const [routeOption, setRouteOption] = useState();
  const [routeChipsList, setRouteChipsList] = useState([]);
  const [selectedRouteChips, setSelectedRouteChips] = useState([]);
  const [row, setRow] = useState(null);
  const [editData, setEditData] = useState(false);
  const [index, setIndex] = useState(null);
  const [searchedDrugList, setSearchedDrugList] = useState([]);
  const [searchedDrugTable, setSearchedDrugTable] = useState([]);
  const [drugId, setDrugId] = useState();
  const [drugNameVal, setDrugNameVal] = useState(null);
  const [alternativeDrugList, setAlternativeDrugList] = useState([]);
  const [selectedItemDtlsID, setSelectedItemDtlsID] = useState(null);
  // const [selectedItemDtlsID, setSelectedItemDtlsID] = useState(null);
  //Alt drug tbl Row id
  const [selectedAltDrugRowID, setSelectedAltDrugRowID] = useState(null);
  // drug tbl Row id
  const [selectedDrugRowID, setSelectedDrugRowID] = useState({});
  const [selectedDrugData, setSelectedDrugData] = useState([]);
  const [selectedDrugRowData, setSelectedDrugRowData] = useState(null);
  const [lastIndex, setLastIndex] = useState();
  const [selectedDrug, setSelectedDrug] = useState(null);
  const [altDrugTableData, setAltDrugTableData] = useState([]);
  const [selectedGenericId, setSelectedGenericId] = useState();
  const [openPost, setOpenPost] = useState(false);
  const [saveData, setSaveData] = useState(false);
  const [existingAllergyData, setExistingAllergyData] = useState([]);
  const [selectedBeforAfterChips, setselectedBeforAfterChips] = useState([]);
  const [selectedInstructionIndex, setSelectedInstructionIndex] =
    useState(null);
  const [beforeAfterIndex, setBeforeAfterIndex] = useState(null);
  const [pastMedication, setPastMedication] = useState(false);
  // const [drugTaperingData, setDrugTaperingData] = useState([]);
  const [openDrugTapering, setOpenDrugTapering] = useState(false);
  const [selectedDrugTaperingRow, setSelectedDrugTaperingRow] = useState(null);
  const [drugTaperingIndex, setDrugTaperingIndex] = useState(null);
  const [drugTaperingDuration, setDrugTaperingDuration] = useState(null);

  const handleCloseChild = () => {};

  const forMedication =
    (actions?.length > 0 &&
      actions?.filter(
        (action) =>
          action.permission === "Is Generic Search" ||
          action.permission === "Is Brand Search"
      )) ||
    [];

  console.log("dataMedication", dataMedication, row);

  let defaultValues = {
    type: "Brand ",
    duration: "",
    searchDrugMedicine: "",
  };
  const durationChips = [
    "1 Day",
    "2 Days",
    "3 Days",
    "4 Days",
    "5 Days",
    "6 Days",
    "7 Days",
    "10 Days",
    "15 Days",
    "1 Month",
    "3 Month",
    "6 Months",
    "1 Year",
    "2 Years",
  ];

  // durationOption
  const durationInOption = [
    {
      value: "1",
      label: "Days",
    },
    {
      value: "2",
      label: "Months",
    },
    {
      value: "3",
      label: "Years",
    },
  ];

  const beforAfterArray = [
    {
      value: "Before",
      label: "B",
      id: "Before",
    },
    {
      value: "After",
      label: "A",
      id: "After",
    },
  ];
  const {
    handleSubmit,
    reset,
    formState: { errors },
    control,
    register,
    setValue,
    watch,
    setError,
    getValues,
  } = useFormContext({
    // resolver: yupResolver(validationSchema),
    // defaultValues: defaultValues,
  });
  let DrugMedicine = watch("searchDrugMedicine");
  let type = watch("type");
  let frequencywatch = watch("frequency");
  let instructions = watch("instructions");
  let medicDuration = watch("medicDuration");
  let MedidurationIn = watch("MedidurationIn");
  let route = watch("route");
  let quantity = watch("quantity");
  let dosage = watch("dosage");
  let ivFlowRate = watch("ivFlowRate");
  let startDate = watch("startDate");
  let note = watch("note");
  const searchInputRef = useRef(null);
  const removeFocusSearch = useRef(null);
  const FocusDrugTable = useRef();
  let drugTapering = watch("drugTapering");
  const [frequencyList, setFrequencyList] = useState([]);

  console.log("startDate321", dataMedication, drugTaperingData);

  const handleSubmitMedication = () => {
    let frequencyListArr = [{ frequency: frequencywatch?.label }];
    let dosageListArr = [{ dosage: dosage }];

    let instructionListArr = [{ instruction: instructions?.label }];

    let durationListArr = [
      { duration: Number(medicDuration), durationIn: MedidurationIn?.label },
    ];
    let startDateListArr = [
      {
        startDate:
          startDate !== undefined
            ? format(startDate, "yyyy-MM-dd")
            : format(new Date(), "yyyy-MM-dd"),
      },
    ];
    if (props.edit === false && editData === false) {
      let obj = {
        drugType: type,
        drugId: selectedDrug?.value,
        code: selectedDrug?.code,
        genericdescription: selectedDrug?.genericdescription,
        drugName:
          forMedication?.length === 2 || forMedication?.length === 0
            ? DrugMedicine
            : DrugMedicine?.label,
        frequency: frequencywatch?.label,
        instruction: instructions?.label,
        duration: Number(medicDuration),
        durationIn: MedidurationIn?.label,
        route: route?.label,
        quantity: quantity,
        dosage: dosage,
        ivFlowRate: ivFlowRate,
        startDate:
          startDate !== undefined
            ? format(startDate, "yyyy-MM-dd")
            : format(new Date(), "yyyy-MM-dd"),
        note: note,
        id: null,
        drugTapering: drugTapering,
        frequencyList: frequencyListArr,
        dosageList: dosageListArr,
        instructionList: instructionListArr,
        durationList: durationListArr,
        startDateList: startDateListArr,
      };
      let temp = dataMedication.some((item) => item.drugName === DrugMedicine);

      if (temp === true && drugTapering === false) {
        warningAlert("Already Present Record..!");
        if (drugTapering === false) {
          setValue("searchDrugMedicine", "");
        }
        setValue("quantity", "");
        // setValue("frequency", null);
        setValue("dosage", "");
        // setValue("instructions", "");
        // setValue("medicDuration", "");
        // setValue("MedidurationIn", null);
        // setValue("route", null);
        setValue("ivFlowRate", "");
        setValue("startDate", new Date());
        setValue("note", "");
        // setSelectedFrequncyChips([]);
        // setSelectedInstructionChips([]);
        // setSelectedRouteChips([]);
        // setSelectedDuration([]);
        setDrugSearchString("");
        setValue("note", "");
        setSelectedDrug(null);
      } else {
        if (DrugMedicine !== "" && DrugMedicine !== undefined) {
          const existingIndex = dataMedication.findIndex(
            (item) => item.drugName === DrugMedicine
          );
          console.log("existingIndex", existingIndex);
          if (drugTapering) {
            if (existingIndex !== -1) {
              const updatedMedication = [...dataMedication];

              const existing = updatedMedication[existingIndex];
              console.log("existing321", existing);

              const updatedEntry = {
                ...existing,
                frequencyList: [
                  ...(existing.frequencyList || []),
                  ...frequencyListArr,
                ],
                dosageList: [...(existing.dosageList || []), ...dosageListArr],
                instructionList: [
                  ...(existing.instructionList || []),
                  ...instructionListArr,
                ],
                durationList: [
                  ...(existing.durationList || []),
                  ...durationListArr,
                ],
                startDateList: [
                  ...(existing.startDateList || []),
                  ...startDateListArr,
                ],
              };

              updatedMedication[existingIndex] = updatedEntry;
              setDataMedication(updatedMedication);
              setDrugTaperingData((prevData) => [
                ...prevData,
                { ...obj, isParent: false },
              ]);
              successAlert("Frequency Added");
              if (
                existing?.durationIn === "Day" ||
                existing?.durationIn === "Days"
              ) {
                const setNewDate = new Date(startDate);
                setNewDate.setDate(
                  setNewDate.getDate() + Number(obj?.duration)
                );
                setValue("startDate", setNewDate);
              }
              console.log("updatedMedication", updatedMedication);
              setOpenDrugTapering(true);
            } else {
              console.log("drugTapering", drugTapering);
              setDataMedication((prevState) => [
                ...prevState,
                { ...obj, isParent: true },
              ]);
              // setDrugTaperingData((prevData) => [...prevData, obj]);
              if (obj?.durationIn === "Day" || obj?.durationIn === "Days") {
                console.log("1236547890", obj);

                const setNewDate = new Date(startDate);
                setNewDate.setDate(
                  setNewDate.getDate() + Number(obj?.duration)
                );
                console.log("setNewDate321", setNewDate);
                setValue("startDate", setNewDate);
                setOpenDrugTapering(true);
              }
            }
          }
          if (drugTapering === false) {
            setValue("searchDrugMedicine", "");
            setValue("quantity", "");
            setDataMedication((prevState) => [
              ...prevState,
              { ...obj, isParent: true },
            ]);
          }

          // setValue("frequency", null);
          setValue("dosage", "");
          // setValue("instructions", "");
          // setValue("medicDuration", "");
          // setValue("MedidurationIn", null);
          // setValue("route", null);
          setValue("ivFlowRate", "");
          // setValue("startDate", new Date());
          setValue("note", "");
          // setSelectedFrequncyChips([]);
          // setSelectedInstructionChips([]);
          // setSelectedRouteChips([]);
          // setSelectedDuration([]);
          setValue("note", "");
          setDrugSearchString("");
          // setSelectedDrug(null);
          // }else{
          //   setError("quantity", { type: "custom", message: "custom message" });

          // }
        } else {
          warningAlert("Please Fill the Record");
        }
      }
    } else if (props.edit === true) {
      let updateobj = {
        drugType: type || props.row["Drug Type"],
        drugId: selectedDrug?.value || props.row.drugId,
        code: selectedDrug?.code || props.row.code,
        genericdescription: selectedDrug?.genericdescription,
        drugName:
          forMedication?.length === 2 || forMedication?.length === 0
            ? DrugMedicine || props.row["Drug Name"]
            : DrugMedicine?.label,
        drugTypeId: drugId,
        frequency: frequencywatch?.label,
        instruction: instructions.label,
        duration: Number(medicDuration),
        durationIn: MedidurationIn?.label,
        route: route?.label,
        quantity: quantity,
        dosage: dosage,
        ivFlowRate: ivFlowRate,
        startDate:
          startDate !== undefined
            ? format(startDate, "yyyy-MM-dd")
            : format(new Date(), "yyyy-MM-dd"),
        note: note,
        id:
          props.row?.id !== undefined &&
          props.row.id !== null &&
          props.row?.id !== ""
            ? props.row?.id
            : null,
        drugTapering: drugTapering || props.row.drugTapering,
        frequencyList: frequencyListArr,
        dosageList: dosageListArr,
        instructionList: instructionListArr,
        durationList: durationListArr,
        startDateList: startDateListArr,
        isParent: props.row.isParent,
      };
      // let duplicateInd = medicationData?.findIndex(
      //   (item, idx) => item.drugName === DrugMedicine && idx !== props.index
      // );
      // if (
      //   duplicateInd === -1 &&
      //   DrugMedicine !== "" &&
      //   DrugMedicine !== undefined
      // ) {
      let reqArr = [...medicationData];
      reqArr.splice(props.index, 1, updateobj);
      setMedicationData(reqArr);
      setDataMedication(reqArr);
      setSelectedFrequncyChips([]);
      setSelectedInstructionChips([]);
      setSelectedRouteChips([]);
      setSelectedDuration([]);
      props.setEdit(false);
      props.setOpenMedicationModal(false);
      setDrugTaperingData([]);
      setValue("searchDrugMedicine", "");
      setValue("quantity", "");
      setValue("frequency", null);
      setValue("dosage", "");
      setValue("instructions", "");
      setValue("medicDuration", "");
      setValue("MedidurationIn", null);
      setValue("route", null);
      setValue("ivFlowRate", "");
      setValue("startDate", new Date());
      setValue("note", "");
      setDrugSearchString("");
      setOpenDrugTapering(false);
      // } else {
      //   warningAlert("Duplicate found, update not applied");
      // }
    } else if (editData === true) {
      let updateobj = {
        drugType: type,
        drugId: selectedDrug?.value,
        code: selectedDrug?.code,
        genericdescription: selectedDrug?.genericdescription,
        drugName:
          forMedication?.length === 2 || forMedication?.length === 0
            ? DrugMedicine
            : DrugMedicine?.label,
        drugTypeId: drugId,
        frequency: frequencywatch?.label,
        instruction: instructions.label,
        duration: Number(medicDuration),
        durationIn: MedidurationIn?.label,
        route: route?.label,
        quantity: quantity,
        dosage: dosage,
        ivFlowRate: ivFlowRate,
        startDate:
          startDate !== undefined
            ? format(startDate, "yyyy-MM-dd")
            : format(new Date(), "yyyy-MM-dd"),
        note: note,
        id:
          row?.id !== undefined && row.id !== null && row?.id !== ""
            ? row?.id
            : null,
        drugTapering: drugTapering,
        frequencyList: frequencyListArr,
        dosageList: dosageListArr,
        instructionList: instructionListArr,
        durationList: durationListArr,
        startDateList: startDateListArr,
        isParent: true,
      };
      // let duplicateInd = dataMedication?.findIndex(
      //   (item, idx) => item.drugName === DrugMedicine && idx !== index
      // );
      // if (
      //   duplicateInd === -1 &&
      //   DrugMedicine !== "" &&
      //   DrugMedicine !== undefined
      // ) {
      // if (drugTaperingIndex !== null) {
      //   let reqArr = [...drugTaperingData];
      //   reqArr.splice(drugTaperingIndex, 1, updateobj);
      //   setDrugTaperingData(reqArr);
      //   setOpenDrugTapering(true)
      //   if (
      //     updateobj?.durationIn === "Day" ||
      //     updateobj?.durationIn === "Days"
      //   ) {
      //     console.log("1236547890", updateobj);

      //     const setNewDate = new Date(startDate);
      //     setNewDate.setDate(
      //       setNewDate.getDate() + Number(updateobj?.duration)
      //     );
      //     console.log("setNewDate321", setNewDate);
      //     setValue("startDate", setNewDate);
      //   }
      // } else {
      let reqArr = [...dataMedication];
      reqArr.splice(index, 1, updateobj);
      setDataMedication(reqArr);
      // }
      setDrugTaperingIndex(null);
      setEditData(false);
      setValue("searchDrugMedicine", "");
      setValue("quantity", "");
      setValue("frequency", null);
      setValue("dosage", "");
      setValue("instructions", "");
      setValue("medicDuration", "");
      setValue("MedidurationIn", null);
      setValue("route", null);
      setValue("ivFlowRate", "");
      setValue("startDate", new Date());
      setValue("note", "");
      setSelectedFrequncyChips([]);
      setSelectedInstructionChips([]);
      setSelectedRouteChips([]);
      setSelectedDuration([]);
      // } else {
      //   warningAlert("Duplicate found, update not applied");
      // }
    }
  };

  let DrugType;
  let GenricFlag;
  let brandFlag;
  let prescriptionTypeValue = watch("type");
  if (prescriptionTypeValue === "Brand") {
    DrugType = "Brand";
    GenricFlag = false;
    brandFlag = true;
  } else if (prescriptionTypeValue === "Generic") {
    DrugType = "Generic";
    GenricFlag = true;
    brandFlag = false;
  }

  // const handleAlternativeDrugList = (selectedDrugId) => {
  //   getAlternativeDrugList(selectedDrugId)
  //     .then((response) => {
  //       setAlternativeDrugList(response.data.result);
  //     })
  //     .catch((error) => {
  //       console.log("Error");
  //     });
  // };

  let isGenericSearch = true;
  let isBrandSearch = false;
  let drugTypes = "Generic";
  //Changes Related to Alternative Drug List
  const handleInputChangeHandler = (drugSearchString) => {
    if (drugSearchString !== undefined && drugSearchString !== "") {
      let obj = {
        isGenericSearch: true,
        isBrandSearch: false,
        drugType: "Generic",
        searchString: drugSearchString,
      };
      prescription(obj)
        .then((response) => {
          setSearchedDrugList(response.data.result);
          // setValue("notes", "");
        })
        .catch((error) => {
          console.log("Error");
        });
    }
  };

  // useEffect(() => {
  //   if (drugTaperingDuration !== null) {
  //     const setNewDate = new Date(startDate);
  //     setNewDate.setDate(setNewDate.getDate() - Number(drugTaperingDuration));
  //     setValue("startDate", setNewDate);
  //   }
  // }, [drugTaperingDuration]);

  //Frequncy Type

  useEffect(() => {
    if (openMedicationModal === true) {
      getFrequency()
        .then((response) => {
          setFrequencyOptions(response.data.result);
        })
        .catch((response) => {
          console.log(response);
        });
    }
  }, [openMedicationModal]);

  const handleFrequncyChips = () => {
    getFrequencyChips()
      .then((response) => {
        setFrequncyChipsList(response.data.result);
      })
      .catch((err) => {
        console.log("Error");
      });
  };
  const handleInstructionChips = () => {
    getInstructionChips()
      .then((response) => {
        setInstructionChipsList(response.data.result);
      })
      .catch((err) => {
        console.log("Error");
      });
  };
  const handleRouteChips = () => {
    getRouteChips()
      .then((response) => {
        setRouteChipsList(response.data.result);
      })
      .catch((err) => {
        console.log("Error");
      });
  };
  //Instruction List
  const handleInstructionChange = (e) => {
    if (e.length > 0) {
      getInstruction(e)
        .then((response) => {
          setInstructionList(response.data.result);
        })
        .catch((response) => {
          console.log(response);
        });
    }
  };

  //Route Type
  useEffect(() => {
    if (openMedicationModal === true) {
      getRoute()
        .then((response) => {
          setRouteOption(response.data.result);
        })
        .catch((response) => {
          console.log(response);
        });
    }
  }, [openMedicationModal]);

  useEffect(() => {
    if (openMedicationModal === true) {
      handleFrequncyChips();
      handleInstructionChips();
      handleRouteChips();
    }
  }, [openMedicationModal]);

  function deleteRow(index) {
    const newComplaintsData = [...dataMedication];
    newComplaintsData.splice(index, 1);
    // setRadiologyData(newComplaintsData);
    setDataMedication(newComplaintsData);
    setSaveData(false);
  }
  const renderAction = (row, index) => {
    return (
      <div className="flex gap-2">
        <Tooltip title="Edit">
          <button
            type="button"
            onClick={() => {
              setRow(null);
              setEditData(true);
              setIndex(index);
              setRow(row);
            }}
          >
            <EditIcon />
          </button>
        </Tooltip>

        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRow(index);
              setSaveData(true);
              if (row?.id !== null && row?.id !== undefined) {
                deleteMedication(row.id)
                  .then((response) => response.data)
                  .then((res) => {
                    if (res.data.statusCode === 200) {
                      successAlert(res.message);
                    }
                    handleCloseChild();
                  })
                  .catch((error) => {
                    // errdeleteAlert(res.message);
                  });
              }
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
        <Tooltip title="">
          {row.drugTapering === true && (
            <button
              type="button"
              onClick={() => {
                setSelectedDrugTaperingRow(row);
                setOpenDrugTapering(true);
              }}
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M9.06391 16.4286C8.86075 16.4286 8.65758 16.36 8.50521 16.2459C8.25125 16.0632 8.12427 15.7663 8.20046 15.4694L9.44484 9.76019L8.75916 10.1027C8.32743 10.3083 7.79413 10.1941 7.54017 9.80587C7.31161 9.41764 7.43859 8.93807 7.87031 8.7097L10.2321 7.49935C10.5369 7.33949 10.9178 7.36233 11.1971 7.54502C11.4765 7.72772 11.6035 8.04743 11.5527 8.34431L10.2575 14.2819L11.3241 13.8708C11.7812 13.6881 12.2892 13.8708 12.4923 14.2819C12.6955 14.693 12.4923 15.1497 12.0352 15.3324L9.41945 16.36C9.31787 16.4057 9.19089 16.4286 9.06391 16.4286ZM11.5781 5.51254C11.8066 5.30701 11.959 5.01013 11.959 4.71325C11.959 4.41637 11.832 4.11949 11.5781 3.91396C11.3495 3.70843 11.0194 3.57141 10.6892 3.57141C10.3591 3.57141 10.0289 3.68559 9.80039 3.91396C9.57182 4.11949 9.41945 4.41637 9.41945 4.71325C9.41945 5.01013 9.54643 5.30701 9.80039 5.51254C10.0289 5.71807 10.3591 5.85509 10.6892 5.85509C11.0194 5.85509 11.3495 5.74091 11.5781 5.51254Z"
                  fill="#1E3A8A"
                />
                <path
                  d="M19.5 10C19.5 4.75429 15.2457 0.5 10 0.5C4.75429 0.5 0.5 4.75429 0.5 10C0.5 15.2457 4.75429 19.5 10 19.5C15.2457 19.5 19.5 15.2457 19.5 10Z"
                  stroke="#1E3A8A"
                />
              </svg>
            </button>
          )}
        </Tooltip>
      </div>
    );
  };

  const handleSaveMedication = () => {
    props.setOpenMedicationModal(false);
    props.setSave(true);
    setEditData(false);
    setValue("searchDrugMedicine", "");
    setValue("drugTapering", false);
  };

  let searchDrugMedicine = watch("searchDrugMedicine");
  console.log("searchDrugMedicine");

  let durationValue = watch("medicDuration");
  let durationInValue = watch("MedidurationIn");
  let frequncyValue = watch("frequency");
  
  useEffect(() => {
    console.log("selectedDrug", selectedDrug);

    if (
      selectedDrug?.itemClass === "TABLET" ||
      selectedDrug?.itemClass === "CAPSULE"
    ) {
      let durationDay = durationValue;
      // let daysinNumber;
      // let totalQuntity;

      let frequencyCount = 0;
      if (frequency) {
        frequency.forEach((element) => {
          let value = element.trim();
          if (value === "1/2" || value === "½") {
            frequencyCount = frequencyCount + 0.5;
          } else if (value === "1") {
            frequencyCount = frequencyCount + 1;
          } else if (value === "1½") {
            frequencyCount = frequencyCount + 1.5;
          } else if (value === "2") {
            frequencyCount = frequencyCount + 2;
          } else if (value === "2½") {
            frequencyCount = frequencyCount + 2.5;
          } else if (value === "3") {
            frequencyCount = frequencyCount + 3;
          } else if (value === "3½") {
            frequencyCount = frequencyCount + 3.5;
          } else if (value === "4") {
            frequencyCount = frequencyCount + 4;
          } else if (value === "4½") {
            frequencyCount = frequencyCount + 4.5;
          } else if (value === "STAT") {
            frequencyCount = frequencyCount + 1;
          } else if (value === "SOS") {
            frequencyCount = frequencyCount + 1;
          } else if (value === "Stat/sos") {
            frequencyCount = frequencyCount + 1;
          } else if (value === "9") {
            frequencyCount = frequencyCount + 9;
          } else {
            frequencyCount = frequencyCount + 0;
          }
        });
      }

      let quantityCount;
      if (
        durationDay !== null &&
        // props.dataId === null &&
        durationInValue &&
        durationInValue !== null
      ) {
        if (
          durationInValue?.label?.toLowerCase() === "days" ||
          durationInValue?.label?.toLowerCase() === "day"
        ) {
          // daysinNumber = durationDay.substring(0, durationDay.indexOf(" "));
          quantityCount =
            parseFloat(durationValue) * parseFloat(frequencyCount);
        } else if (
          durationInValue?.label?.toLowerCase() === "months" ||
          durationInValue?.label?.toLowerCase() === "month"
        ) {
          // daysinNumber = durationDay.substring(0, durationDay.indexOf(" "));
          let quantityInMonths =
            parseFloat(durationValue) * parseFloat(frequencyCount);
          quantityCount = parseFloat(quantityInMonths) * 30;
        } else {
          // daysinNumber = durationDay.substring(0, durationDay.indexOf(" "));
          let quantityInYears =
            parseFloat(durationValue) * parseFloat(frequencyCount);
          quantityCount = parseFloat(quantityInYears) * 365;
        }

        let totalQuantity = Math.ceil(quantityCount);
        setValue("quantity", totalQuantity, { shouldValidate: true });
      }
    }
  }, [durationValue, frequency, frequncyValue, selectedDrug]);

  

  let freqArray;
  useEffect(() => {
    if (frequncyValue?.label !== undefined && frequncyValue !== null) {
      freqArray = frequncyValue.label?.split("-");
      setFrequency(freqArray);
    }
  }, [frequncyValue, durationInValue]);
  useEffect(() => {
    if (props.edit === true) {
      // type
      let obj = {
        id: props.row["Drug Type"],
        label: props.row["Drug Type"],
        value: props.row["Drug Type"],
      };
      setValue(
        "type",
        props.row["Drug Type"] === "Brand" ? "Brand" : "Generic"
      );
      setSelectedDrug(props.row["itemClass"]);

      let drugName = {
        id: props.row["Drug Name"],
        label: props.row["Drug Name"],
        value: props.row["Drug Name"],
      };
      setValue(
        "searchDrugMedicine",
        forMedication?.length !== 2 && forMedication?.length > 0
          ? drugName
          : props.row["Drug Name"]
      );
      let frequencyObj = {
        label: props.row["Frequency"],
        valaue: props.row["Frequency"],
      };
      setValue("frequency", frequencyObj);
      let instructionsObj = {
        label: props.row["Instructions"],
        valaue: props.row["Instructions"],
      };
      setValue("instructions", instructionsObj);
      setValue("medicDuration", props.row["Durations"]);
      // .replace(/\bDays\b/i, "").trim()
      // let day = props.row["Duration"]?.trim()?.split(" ");
      let durationObj = {
        label: props.row.DurationIn,
        value: props.row.DurationIn,
      };
      setValue("MedidurationIn", durationObj);
      let routeobj = {
        label: props.row["Route"],
        // value: props.row["Route"],
      };
      setValue("route", routeobj);
      setValue("quantity", props.row["Quantity"]);
      setValue("ivFlowRate", props.row["IvFlowRate"]);
      setValue("note", props.row["Note"]);
      let conceptionDate;
      if (
        props.row["StartDate"] !== null ||
        props.row["StartDate"] !== undefined
      ) {
        conceptionDate = new Date(props.row["StartDate"]);
      }
      setValue("startDate", conceptionDate);
      setValue("dosage", props.row?.Dosage);
    }
  }, [props.edit]);

  useEffect(() => {
    if (row !== null) {
      console.log("row9090", row);

      let obj = {
        id: row["Drug Type"] || row.drugType,
        label: row["Drug Type"] || row.drugType,
        value: row["Drug Type"] || row.drugType,
      };
      setValue(
        "type",
        row["Drug Type"] === "Brand" || row.drugType ? "Brand" : "Generic"
      );
      let drugName = {
        id: row["Drug Name"] || row.drugName,
        label: row["Drug Name"] || row.drugName,
        value: row["Drug Name"] || row.drugName,
      };
      setValue(
        "searchDrugMedicine",
        forMedication?.length !== 2 && forMedication?.length > 0
          ? drugName
          : row["Drug Name"] || row.drugName
      );
      let frequencyObj = {
        label: row["Frequency"] || row.frequency,
        valaue: row["Frequency"] || row.frequency,
      };
      setValue("frequency", frequencyObj);
      let instructionsObj = {
        label: row["Instructions"] || row.instruction,
        valaue: row["Instructions"] || row.instruction,
      };
      setValue("instructions", instructionsObj);
      setValue("medicDuration", row["Durations"] || row.duration);
      // let day = row["Duration"]?.trim()?.split(" ");
      let durationObj = {
        label: row.DurationIn || row.durationIn,
        value: row.DurationIn || row.durationIn,
      };
      setValue("MedidurationIn", durationObj);
      let routeobj = {
        label: row["Route"] || row.route,
        // value: row["Route"],
      };
      setValue("route", routeobj);
      setValue("quantity", row["Quantity"] || row.quantity);
      setValue("ivFlowRate", row["IvFlowRate"]);
      setValue("note", row["Note"] || row.note);
      let conceptionDate;
      if (
        row["StartDate"] !== "" ||
        (row.startDate !== "" && row["StartDate"] !== undefined) ||
        row.startDate !== undefined
      ) {
        conceptionDate = new Date(row["StartDate"] || row.startDate);
      }
      setValue("startDate", conceptionDate);
      setValue("dosage", row?.Dosage || row.dosage);
      setValue("drugTapering", row?.drugTapering);
    }
  }, [row]);

  const handleChangeDrug = (searchValue) => {
    if (searchValue !== undefined && searchValue !== "") {
      let obj = {
        isGenericSearch: GenricFlag,
        isBrandSearch: brandFlag,
        drugType: DrugType,
        searchString: searchValue,
      };
      prescription(obj)
        .then((response) => {
          setSearchedDrugTable(response.data.result);
          // setValue("quantity", "");
          // setValue("frequency", null);
          // setValue("dosage", "");
          // setValue("instruction", "");
          // setValue("duration", "");
          // setValue("durationIn", null);
          // setValue("route", null);
          // setValue("ivFlowRate", "");
          // setValue("startDate", new Date());
          // setValue("note", "");
          // setValue("notes", "");
        })
        .catch((error) => {
          console.log("Error");
        });
    } else {
      setSearchedDrugTable([]);
      setAltDrugTableData([]);
      setSelectedFrequncyChips([]);
      setSelectedInstructionChips([]);
      setSelectedRouteChips([]);
      setSelectedDuration([]);
      setDrugSearchString("");
      setValue("frequency", null);
      setValue("medicDuration", "");
      setValue("MedidurationIn", null);
    }
  };
  useEffect(() => {
    if (
      selectedDrugRowData !== null &&
      selectedDrugRowData !== undefined &&
      selectedDrugRowData?.genericid !== undefined
    ) {
      getGenaricTable(
        selectedDrugRowData?.value,
        selectedDrugRowData?.genericid
      )
        .then((response) => response.data)
        .then((res) => {
          setAltDrugTableData(res.result);
        });
    }
  }, [selectedDrugRowData]);

  useEffect(() => {
    if (searchedDrugTable?.length === 0) {
      setAltDrugTableData([]);
      setSelectedDrugData(null);
    }
  }, [searchedDrugTable]);

  useEffect(() => {
    if (
      dataMedication !== null &&
      dataMedication?.length > 0 &&
      props.edit === false
    ) {
      const nonParentRecords = dataMedication.filter(
        (item) => item.isParent === false
      );
      // const nonParentRecords = dataMedication
      // ?.filter(
      //   (row) => row.drugId === selectedDrugTaperingRow?.drugId &&  row.isParent === false
      // )

      console.log("nonParentRecords", nonParentRecords);
      if (nonParentRecords?.length > 0) {
        setDrugTaperingData((prev) => [...prev, ...nonParentRecords]);
      }
    }
  }, [dataMedication]);

  useEffect(() => {
    if (selectedDrug !== null) {
      setValue(
        "searchDrugMedicine",
        selectedDrug?.["Medicine"] === undefined
          ? selectedDrug?.["Item Name"]
          : selectedDrug?.["Medicine"]
      );
      setDrugId(selectedDrug?.Id);

      // let Frequencyobj = {
      //   label: selectedDrug?.["Frequency"],
      //   value: selectedDrug?.["Frequency"],
      // };
      // setValue("frequency", Frequencyobj);
      // let routeobj = {
      //   label: selectedDrug?.["Route"],
      //   value: selectedDrug?.["Route"],
      // };
      // setValue("route", routeobj);
      // if (selectedDrug !== null && patientDetails !== null) {
      //   setValue(
      //     "input-1",
      //     selectedDrug && selectedDrug["searchDrugMedicine"]
      //       ? selectedDrug["searchDrugMedicine"]
      //       : selectedDrug.Drug
      //   );
      //   inputRefTwo.current.focus();
    }

    // setSelectedAltDrugData()
  }, [selectedDrug]);

  const removeFocusInputSearch = () => {
    if (removeFocusSearch.current) {
      removeFocusSearch.current.blur();
    }
  };
  const handleCloseModel = () => {
    setOpenPost(false);
    setSaveData(false);
    setDataMedication(existingAllergyData);
    setOpenMedicationModal(false);

    props.setEditOpen(false);
    props.setEdit(false);
    setEditData(false);
    setValue("searchDrugMedicine", "");
    setValue("quantity", "");
    setValue("frequency", null);
    setValue("dosage", "");
    setValue("instructions", "");
    setValue("medicDuration", "");
    setValue("MedidurationIn", null);
    setValue("route", null);
    setValue("ivFlowRate", "");
    setValue("startDate", null);
    setDrugSearchString("");
  };
  useEffect(() => {
    if (props.openMedicationModal) {
      setExistingAllergyData(dataMedication);
    }
  }, [props.openMedicationModal]);

  const handlePastMedication = () => {
    getPastMedication(props.patientData.patientId).then((response) => {
      setDataMedication((prev) => [...prev, ...response.data.result]);
      setPastMedication(true);
    });
  };
  // const handlePastMedication = () => {
  //   getPastMedication(props.patientData.patientId).then((response) => {
  //     const modifiedResult = response.data.result.map((item) => ({
  //       ...item,
  //       isParent: true,
  //     }));
  //     setDataMedication((prev) => [...prev, ...modifiedResult]);
  //     setPastMedication(true);
  //   });
  // };

  const mergeMedicationArray = (arr) => {
    console.log("arrarrarrarr", arr);

    if (arr.drugTapering === false) {
      return arr.reduce((acc, val) => {
        const ind = acc.findIndex(
          (item) => item["Drug Name"] === val["Drug Name"]
        );
        if (ind !== -1) {
          console.log("Service Already Exists");
        } else {
          acc.push(val);
        }
        return acc;
      }, []);
    }

    // If drugTapering is true or not specified, you can handle it here if needed
    return arr;
  };

  console.log("drugTaperingData", drugTaperingData);

  function deleteRowDrugTapering(index, row) {
    const newData = [...drugTaperingData];

    const deletedRowStartDate = newData[index]?.startDate;

    // Delete the row
    newData.splice(index, 1);

    // If there's a next row, update its startDate
    if (index < newData.length) {
      newData[index].startDate = deletedRowStartDate;

      // If you have startDateList, update that too
      if (newData[index].startDateList?.length > 0) {
        newData[index].startDateList[0].startDate = deletedRowStartDate;
      }
    }

    setDrugTaperingData(newData);
    setSaveData(false);
  }

  const renderActionDrugTapering = (row, index) => {
    return (
      <div className="flex gap-2">
        {/* <Tooltip title="Edit">
          <button
            type="button"
            onClick={() => {
              setEditData(true);
              setDrugTaperingIndex(true);
              setRow(row);
            }}
          >
            <EditIcon />
          </button>
        </Tooltip> */}

        <Tooltip title="Delete">
          <button
            type="button"
            onClick={() => {
              deleteRowDrugTapering(index, row);
            }}
          >
            <DeleteIcon />
          </button>
        </Tooltip>
      </div>
    );
  };

  console.log("The data on medicationsModal :");

  console.log("selectedDrugTaperingRow321", selectedDrugTaperingRow);
  console.log("drugTaperingData", drugTaperingData);

  return (
    <div>
      <Modal
        open={openMedicationModal}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: "95%",
            height: "95%",
            // maxHeight: "75%",
            overflow: "auto",
            overflowY: "scroll",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
          }}
        >
          {/* <form onSubmit={handleSubmit(onSubmit)}> */}
          <div className="text-base font-semibold  mb-4 flex justify-between">
            <div className="flex space-x-2">
              <h1>Medicine</h1>
              {/* <PastHistoryMedication /> */}
              <div className="flex space-x-2">
                <input
                  type="checkbox"
                  name="drugTapering"
                  {...register("drugTapering")}
                />
                <label>Drug Tapering</label>
              </div>
            </div>

            <div className="-mt-2">
              <CancelPresentationIconButton
                onClick={() => {
                  if (saveData === true) {
                    setOpenPost(true);
                    setSelectedFrequncyChips([]);
                    setSelectedInstructionChips([]);
                    setSelectedRouteChips([]);
                    setSelectedDuration([]);
                    setOpenDrugTapering(false);
                    setSelectedDrugTaperingRow(null);
                  } else {
                    setOpenMedicationModal(false);
                    setAltDrugTableData([]);
                    props.setEditOpen(false);
                    props.setEdit(false);
                    setEditData(false);
                    setValue("searchDrugMedicine", "");
                    setValue("quantity", "");
                    setValue("frequency", null);
                    setValue("dosage", "");
                    setValue("instructions", "");
                    setValue("medicDuration", "");
                    setValue("MedidurationIn", null);
                    setValue("route", null);
                    setValue("ivFlowRate", "");
                    setValue("startDate", new Date());
                    setDrugSearchString("");
                    setSelectedFrequncyChips([]);
                    setSelectedInstructionChips([]);
                    setSelectedRouteChips([]);
                    setSelectedDuration([]);
                    setOpenDrugTapering(false);
                    setSelectedDrugTaperingRow(null);
                  }
                }}
              />
            </div>
          </div>
          <div className="grid xl:grid-cols-2 lg:grid-cols-2 md:grid-cols-1 2xl:grid-cols-2 gap-2">
            <div>
              {/* <RadioField control={control} name="type" dataArray={typeData} /> */}
              {forMedication?.length === 2 || forMedication?.length <= 0 ? (
                <>
                  <fieldset
                    onChange={() => {
                      setValue("searchDrugMedicine", "");
                      setDrugSearchString("");
                      setSelectedDrugData(null);
                      setSelectedFrequncyChips([]);
                      setSelectedInstructionChips([]);
                      setSelectedRouteChips([]);
                      setSelectedDuration([]);
                      setEditData(false);
                      setValue("searchDrugMedicine", "");
                      setValue("quantity", "");
                      setValue("frequency", null);
                      setValue("dosage", "");
                      setValue("instructions", "");
                      setValue("medicDuration", "");
                      setValue("MedidurationIn", null);
                      setValue("route", null);
                      setValue("ivFlowRate", "");
                      setValue("startDate", new Date());
                      setOpenDrugTapering(false);
                      setSelectedDrugTaperingRow(null);
                    }}
                  >
                    <RadioField
                      control={control}
                      name="type"
                      dataArray={typeData}
                    />
                  </fieldset>
                  <div className="flex gap-2">
                    <div>
                      {" "}
                      <InputField
                        control={control}
                        value={drugNameVal}
                        // error={errors.allergyType}
                        name="searchDrugMedicine"
                        label=" Drug/ Medicine*"
                        searchIcon={true}
                        ref={searchInputRef}
                        inputRef={{
                          ...register("searchDrugMedicine", {
                            onChange: (e) => {
                              if (e.target.value === "") {
                                setValue("input-1", "");
                                setDrugSearchString("");
                                setSelectedDrugData(null);
                                setSelectedDrug(null);
                                setAltDrugTableData([]);
                                setSelectedFrequncyChips([]);
                                setSelectedInstructionChips([]);
                                setSelectedRouteChips([]);
                                setSelectedDuration([]);
                                setValue("frequency", null);
                                setValue("medicDuration", "");
                                setValue("MedidurationIn", null);
                                setValue("quantity", null);
                                setValue("startDate", new Date());
                                setOpenDrugTapering(false);
                                setSelectedDrugTaperingRow(null);

                                // setDrugSearchString("");
                                // selectedDrugRowData(null)
                              } else if (e.target.value !== "") {
                                setDrugSearchString(e.target.value);
                                handleChangeDrug(e.target.value);
                                setOpenDrugTapering(false);
                                setSelectedDrugTaperingRow(null);
                              }
                            },
                          }),
                        }}
                        autoFocus
                      />
                    </div>

                    <div className="flex space-x-2 mt-1">
                      {patientData?.department === "Paediatrics" && (
                        <>
                          <div className="flex space-x-2">
                            <h1 className="font-semibold">Height :</h1>
                            <h1>{height}</h1>
                          </div>
                          <div className="flex space-x-2">
                            <h1 className="font-semibold">weight :</h1>
                            <h1>{weight}</h1>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </>
              ) : forMedication?.length === 1 ? (
                <SearchDropdown
                  control={control}
                  value={drugNameVal}
                  name="searchDrugMedicine"
                  placeholder=" Drug/ Medicine"
                  dataArray={searchedDrugList}
                  handleInputChange={handleInputChangeHandler}
                  // inputRef={{
                  //   ...register("searchDrugMedicine", {
                  //     onChange: (e) => {
                  //       console.log("e.target.value", e.target.value);
                  //       // setValue("searchDrugMedicine", "");
                  //       // setDrugSearchString("");
                  //       setSearchedDrugList([]);
                  //       setAltDrugTableData([]);
                  //       setSelectedDrugRowData([]);
                  //       setSelectedDrug(null);
                  //       if (e.target.value === "") {
                  //         setValue("input-1", "");
                  //         setDrugSearchString("");
                  //         setSelectedDrugData(null);
                  //         setSelectedDrug(null);
                  //         setAltDrugTableData([]);
                  //         setSearchedDrugList([]);

                  //         // selectedDrugRowData(null)
                  //       } else if (e.target.value !== "") {
                  //         setDrugSearchString(e.target.value);
                  //       }
                  //     },
                  //   }),
                  // }}
                />
              ) : (
                ""
              )}
            </div>
            <div className="flex justify-end">
              {props.from === "template" ? (
                ""
              ) : (
                <CommonButton
                  type="button"
                  label="Past Medication"
                  className="bg-customBlue text-white"
                  disabled={pastMedication === true}
                  onClick={() => {
                    handlePastMedication();
                  }}
                />
              )}
            </div>
            {/* {searchDrugMedicine !== "" ? (
              <>
                {" "}
                {searchedDrugList?.length > 0 ? (
                  <div className="w-full col-span-2">
                    <AlternativeMedicineTable
                      leftTableData={searchedDrugList}
                      rightTableData={alternativeDrugList}
                      handleAlternativeDrugList={handleAlternativeDrugList}
                      handleSelectedDrug={handleSelectedDrug}
                      drugTypeVal={DrugType}
                    />
                  </div>
                ) : null}
              </>
            ) : null} */}
            {drugSearchString !== "" ? (
              <>
                <div>
                  {searchedDrugTable?.length > 0 ? (
                    <Medicationtable
                      data={searchedDrugTable}
                      setSelectedDrug={setSelectedDrug}
                      setSelectedDrugRowID={setSelectedDrugRowID}
                      setSelectedItemDtlsID={setSelectedItemDtlsID}
                      setDrugTableData={setSearchedDrugTable}
                      setAltDrugTableData={setAltDrugTableData}
                      selectedGenericId={selectedGenericId}
                      setSelectedGenericId={setSelectedGenericId}
                      setSelectedDrugRowData={setSelectedDrugRowData}
                      setSelectedDrugData={setSelectedDrugData}
                      selectedDrugData={selectedDrugData}
                      selectedDrugRowID={selectedDrugRowID}
                      lastIndex={lastIndex}
                      setLastIndex={setLastIndex}
                      setSelectedAltDrugRowID={setSelectedAltDrugRowID}
                      selectedAltDrugRowID={selectedAltDrugRowID}
                      setDrugSearchString={setDrugSearchString}
                      removeFocusInputSearch={removeFocusInputSearch}
                    />
                  ) : (
                    ""
                  )}
                </div>

                <div>
                  {altDrugTableData?.length > 0 ? (
                    <AltDrugTable
                      data={altDrugTableData}
                      setSelectedDrug={setSelectedDrug}
                      selectedItemDtlsID={selectedItemDtlsID}
                      setSelectedItemDtlsID={setSelectedItemDtlsID}
                      setAltDrugTableData={setAltDrugTableData}
                      setDrugTableData={setSearchedDrugTable}
                      setSelectedDrugData={setSelectedDrugData}
                      selectedDrugData={selectedDrugData}
                      setSelectedDrugRowData={setSelectedDrugRowData}
                      selectedAltDrugRowID={selectedAltDrugRowID}
                      setSelectedAltDrugRowID={setSelectedAltDrugRowID}
                      setSelectedDrugRowID={setSelectedDrugRowID}
                      selectedDrugRowID={selectedDrugRowID}
                      setDrugSearchString={setDrugSearchString}
                      lastIndex={lastIndex}
                      removeFocusInputSearch={removeFocusInputSearch}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </>
            ) : (
              ""
            )}
            <div>
              <div className="flex justify-between bg-[#FFE6C9] rounded-t-md">
                <p className="text-sm font-semibold pl-2 py-2 mt-1">
                  Frequency{" "}
                </p>
                <div className="flex w-[30%] m-1">
                  <CreateableSelect
                    // ref={selectRef}
                    focused={true}
                    control={control}
                    // error={errors.allergyType}
                    name="frequency"
                    label="Frequency*"
                    placeholder="Frequency"
                    dataArray={frequencyOptions}
                    // isSearchable={false}
                    // handleChange={handleFrequncy}
                    // onInputChange={handleFrequncy}
                    inputRef={{
                      ...register("frequency", {
                        onChange: (e) => {
                          if (selectedFrequncyChips?.length > 0) {
                            console.log(
                              "selectedFrequncyChips",
                              selectedFrequncyChips
                            );
                            setSelectedFrequncyChips([]);
                          }
                        },
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="p-2 border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
                <div className="flex justify-between ">
                  <div className="flex flex-wrap space-x-2 pl-2">
                    {/* {frequncyChipsList &&
                      frequncyChipsList
                        .slice(0, chipsCount)
                        .map((item, index) => {
                          const isSelected =
                            selectedFrequncyChips.includes(item);
                          return (
                            <>
                             
                              <button
                                type="button"
                               
                                key={index}
                                className={`border border-${
                                  isSelected ? "none" : "gray-400"
                                } center relative inline-block select-none whitespace-nowrap rounded-full bg-${
                                  isSelected ? "customBlue" : "white"
                                } py-1.5 px-3.5 my-1 align-baseline text-xs  leading-none text-${
                                  isSelected ? "white" : "black"
                                }`}
                                disabled={
                                  selectedFrequncyChips.includes(item)
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  if (selectedFrequncyChips.includes(item)) {
                                
                                  } else {
                                    setSelectedFrequncyChips([item]);
                                    console.log(
                                      "item",
                                      item,
                                      selectedFrequncyChips,
                                      selectedFrequncyChips.includes(item)
                                    );
                                    setValue("frequency", item);
                                  }
                                }}
                              >
                                {item.label}
                              </button>
                            </>
                          );
                        })} */}

                    {frequncyChipsList &&
                      frequncyChipsList
                        .filter((item) => item.isCommon) // Filter only items where isCommon is true
                        // .slice(0, chipsCount)
                        .map((item, index) => {
                          const isSelected =
                            selectedFrequncyChips.includes(item);
                          return (
                            <button
                              type="button"
                              key={index}
                              className={`border border-${
                                isSelected ? "none" : "gray-400"
                              } center relative inline-block select-none whitespace-nowrap rounded-full bg-${
                                isSelected ? "customBlue" : "white"
                              } py-1.5 px-3.5 my-1 align-baseline text-xs leading-none text-${
                                isSelected ? "white" : "black"
                              }`}
                              disabled={isSelected}
                              onClick={() => {
                                if (!isSelected) {
                                  setSelectedFrequncyChips([item]);

                                  setValue("frequency", item);
                                }
                              }}
                            >
                              {item.label}
                            </button>
                          );
                        })}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="flex justify-between bg-[#FCE7F3] rounded-t-md">
                <p className="text-sm font-semibold pl-2 py-2 mt-1">
                  Instructions{" "}
                </p>
                <div className="flex  w-[30%] m-1">
                  <CreateableSelect
                    // ref={selectRef}
                    focused={true}
                    control={control}
                    // error={errors.allergyType}
                    name="instructions"
                    label="Instructions*"
                    placeholder="Instructions"
                    dataArray={instructionList}
                    isSearchable={false}
                    handleChange={handleInstructionChange}
                    onInputChange={handleInstructionChange}
                    autoFocus
                    inputRef={{
                      ...register("instructions", {
                        onChange: (e) => {
                          if (selectedInstructionChips?.length > 0) {
                            console.log(
                              "selectedInstructionChips",
                              selectedInstructionChips
                            );
                            setSelectedInstructionChips([]);
                          }
                        },
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="p-2 border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
                <div className="flex justify-between ">
                  <div className="flex flex-wrap space-x-2 pl-2">
                    {instructionChipsList &&
                      instructionChipsList
                        // .slice(0, chipsInstruction)
                        .map((item, index) => {
                          const isSelected =
                            selectedInstructionChips.includes(item);
                          const isCurrentIndex =
                            index === selectedInstructionIndex;
                          return (
                            <div className="grid">
                              {/* {item.isCommon && ( */}
                              <button
                                type="button"
                                // className="border border-black center relative inline-block select-none whitespace-nowrap rounded-full bg-white py-2 px-3.5 align-baseline text-xs  leading-none text-black"
                                key={index}
                                className={`border border-${
                                  isSelected ? "none" : "gray-400"
                                } center relative inline-block select-none whitespace-nowrap rounded-full bg-${
                                  isSelected ? "customBlue" : "white"
                                } py-1.5 px-3.5 my-1 align-baseline text-xs  leading-none text-${
                                  isSelected ? "white" : "black"
                                }`}
                                // disabled={
                                //   selectedInstructionChips.includes(item)
                                //     ? true
                                //     : false
                                // }
                                onClick={() => {
                                  // if (selectedInstructionChips.includes(item)) {
                                  //   // setSelectedChips(
                                  //   //   selectedChips.filter(
                                  //   //     (selectedChip) => selectedChip !== item
                                  //   //   )
                                  //   // );
                                  // } else {
                                  //   setSelectedInstructionChips([item]);
                                  //   // setSelectedInstructionIndex(index)
                                  // }
                                  setSelectedInstructionChips([item]);
                                  setValue("instructions", item);
                                }}
                                // disabled={frequency?.[index]?.trim() === "0"}
                              >
                                {item.label}
                              </button>
                              {/* <fieldset className="flex gap-2" disabled={frequency?.[index]?.trim() === "0"}>
                                {beforAfterArray.map((row,rowIndex) => {
                                  
                                  console.log("isSelected", isSelected);
                                  const isBeforAfterSelected = selectedBeforAfterChips?.label === row?.label && isCurrentIndex;;
                                  // const isDisabled = beforeAfterIndex !== selectedInstructionIndex;
                                  console.log("isBeforAfterSelected",isBeforAfterSelected,beforeAfterIndex,selectedInstructionIndex);
                                  const isDisabled = !isCurrentIndex;
                                  return (
                                    <button
                                      type="button"
                                      // className="border border-black center relative inline-block select-none whitespace-nowrap rounded-full bg-white py-2 px-3.5 align-baseline text-xs  leading-none text-black"
                                      key={rowIndex}
                                      className={`border border-${
                                        isBeforAfterSelected ? "none" : "gray-400"
                                      } center relative inline-block select-none whitespace-nowrap rounded-full bg-${
                                        isBeforAfterSelected ? "customBlue" : "white"
                                      } py-1.5 px-3.5 my-1 align-baseline text-xs  leading-none text-${
                                        isBeforAfterSelected ? "white" : "black"
                                      }`}
                                      // disabled={
                                      //   selectedInstructionChips.includes(item)
                                      //     ? true
                                      //     : false
                                      // }
                                      onClick={() => {
                                        setselectedBeforAfterChips(row);
                                        setBeforeAfterIndex(rowIndex)
                                      }}
                                      disabled={isDisabled}
                                    >
                                      {row.label}
                                    </button>
                                  );
                                })}
                              </fieldset> */}
                              {/* )} */}
                            </div>
                          );
                        })}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="flex justify-between bg-[#FCCBF7] rounded-t-md">
                <p className="text-sm font-semibold pl-2 py-2 mt-1">
                  Duration{" "}
                </p>
                <div className="flex space-x-2  w-[50%] m-1">
                  <InputField
                    control={control}
                    // error={errors.allergyType}
                    name="medicDuration"
                    label="Duration"
                    placeholder="Duration"
                    inputRef={{
                      ...register("medicDuration", {
                        onChange: (e) => {
                          if (selectedDuration?.length > 0) {
                            console.log("selectedDuration", selectedDuration);
                            setSelectedDuration([]);
                          }
                        },
                      }),
                    }}
                  />
                  <CreateableSelect
                    // ref={selectRef}
                    focused={true}
                    control={control}
                    // error={errors.allergyType}
                    name="MedidurationIn"
                    label="Duration In*"
                    placeholder="Duration In"
                    dataArray={durationInOption}
                    // handleChange={handleChange}
                    // onInputChange={handleChange}
                    inputRef={{
                      ...register("MedidurationIn", {
                        onChange: (e) => {
                          if (selectedDuration?.length > 0) {
                            console.log("selectedDuration", selectedDuration);
                            setSelectedDuration([]);
                          }
                        },
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="p-2 border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
                <div className="flex justify-between ">
                  <div className="flex flex-wrap space-x-2 pl-2">
                    {durationChips &&
                      durationChips.map((item, index) => {
                        const isSelected = selectedDuration.includes(item);
                        return (
                          <button
                            type="button"
                            key={index}
                            className={`border border-${
                              isSelected ? "none" : "gray-400"
                            } center relative inline-block select-none whitespace-nowrap rounded-full bg-${
                              isSelected ? "customBlue" : "white"
                            } py-1.5 px-3.5 my-1 align-baseline text-xs  leading-none text-${
                              isSelected ? "white" : "black"
                            }`}
                            onClick={() => {
                              setSelectedDuration([item]);
                              let splitDuration = item?.split(" ");
                              let durationLabel;
                              if (
                                splitDuration[1].toLowerCase() === "day" ||
                                splitDuration[1].toLowerCase() === "days"
                              ) {
                                durationLabel = "Days";
                              } else if (
                                splitDuration[1].toLowerCase() === "month" ||
                                splitDuration[1].toLowerCase() === "months"
                              ) {
                                durationLabel = "Months";
                              } else {
                                durationLabel = "Years";
                              }
                              setValue(
                                "medicDuration",
                                parseInt(splitDuration[0]),
                                {
                                  shouldValidate: true,
                                }
                              );
                              setValue(
                                "MedidurationIn",
                                {
                                  value: 1,
                                  label: durationLabel,
                                },
                                { shouldValidate: true }
                              );
                            }}
                          >
                            {item}
                          </button>
                        );
                      })}
                  </div>
                </div>
              </div>
            </div>
            <div>
              <div className="flex justify-between bg-[#DCFCE7] rounded-t-md">
                <p className="text-sm font-semibold pl-2 py-2 mt-1">Route </p>
                <div className="flex  w-[30%] m-1">
                  <CreateableSelect
                    // ref={selectRef}
                    focused={true}
                    control={control}
                    // error={errors.allergyType}
                    name="route"
                    label="Route*"
                    placeholder="Route"
                    dataArray={routeOption}
                    inputRef={{
                      ...register("route", {
                        onChange: (e) => {
                          if (selectedRouteChips?.length > 0) {
                            console.log(
                              "selectedRouteChips",
                              selectedRouteChips
                            );
                            setSelectedRouteChips([]);
                          }
                        },
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="p-2 border pb-2 border-b-[#D9D9D9] border-r-[#D9D9D9] border-l-[#D9D9D9] bg-white rounded-b-md">
                <div className="flex justify-between ">
                  <div className="flex flex-wrap space-x-2 pl-2">
                    {routeChipsList &&
                      routeChipsList
                        // .slice(0, chipsCount)
                        .map((item, index) => {
                          const isSelected = selectedRouteChips.includes(item);
                          return (
                            <>
                              {/* {item.isCommon && ( */}
                              <button
                                type="button"
                                // className="border border-black center relative inline-block select-none whitespace-nowrap rounded-full bg-white py-2 px-3.5 align-baseline text-xs  leading-none text-black"
                                key={index}
                                className={`border border-${
                                  isSelected ? "none" : "gray-400"
                                } center relative inline-block select-none whitespace-nowrap rounded-full bg-${
                                  isSelected ? "customBlue" : "white"
                                } py-1.5 px-3.5 my-1 align-baseline text-xs  leading-none text-${
                                  isSelected ? "white" : "black"
                                }`}
                                disabled={
                                  selectedRouteChips.includes(item)
                                    ? true
                                    : false
                                }
                                onClick={() => {
                                  if (selectedRouteChips.includes(item)) {
                                    // setSelectedChips(
                                    //   selectedChips.filter(
                                    //     (selectedChip) => selectedChip !== item
                                    //   )
                                    // );
                                  } else {
                                    setSelectedRouteChips([item]);
                                  }
                                  setValue("route", item, {
                                    shouldValidate: true,
                                  });
                                }}
                              >
                                {item.label}
                              </button>
                              {/* )} */}
                            </>
                          );
                        })}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="flex space-x-2 my-2">
              <div className="flex w-[20%] space-x-2">
                <InputField
                  control={control}
                  name="quantity"
                  label="Quantity"
                  type="number"
                  error={errors.quantity}
                />
                <InputField control={control} name="dosage" label="Dosage" />
              </div>
              {/* <div className="w-[20%] ">
                <InputField
                  control={control}
                  name="ivFlowRate"
                  label="IV Flow Rate"
                  type="number"
                />
              </div> */}

              <div className="w-[20%] flex space-x-2">
                <InputField control={control} name="note" label="Note" />
              </div>

              <div className="flex gap-2">
                {props.from === "template" ? (
                  ""
                ) : (
                  <DatePickerField
                    control={control}
                    name="startDate"
                    label="Start Date"
                    inputFormat="dd-MM-yyyy"
                    defaultValue={new Date()}
                    disablePast
                  />
                )}
                {props.edit === false && editData === false ? (
                  <CommonButton
                    label="Add"
                    type="button"
                    onClick={() => {
                      // if(drugTapering === false) {

                      handleSubmitMedication();
                      // } else {
                      //   handleSubmitMedicationTapering();

                      // }
                      setSaveData(true);
                    }}
                    className="addButton bg-customBlue text-white"
                  />
                ) : (
                  <CommonButton
                    label="Update"
                    type="button"
                    onClick={() => {
                      // if(drugTapering === false) {

                      handleSubmitMedication();
                      // } else {
                      //   handleSubmitMedicationTapering();

                      // }
                      setSaveData(true);
                    }}
                    className="addButton bg-customBlue text-white"
                  />
                )}
                <CommonButton
                  label="Reset"
                  className="border border-customRed text-customRed"
                  onClick={() => {
                    setValue("", "");

                    setValue("instructions", "");
                    setValue("medicDuration", "");
                    setValue("MedidurationIn", null);
                    setValue("route", null);
                    setValue("frequency", null);
                    setSelectedFrequncyChips([]);
                    setSelectedInstructionChips([]);
                    setSelectedRouteChips([]);
                    setSelectedDuration([]);
                  }}
                />
              </div>
            </div>
          </div>
          <div>
            {props.edit === false && dataMedication?.length > 0 ? (
              <>
                {mergeMedicationArray(
                  dataMedication
                    .filter((row) => row.isParent === true)
                    .map((row) => ({
                      "Drug Type": row.drugType,
                      "Drug Name": row.drugName,
                      Frequency: row.frequency,
                      Dosage: row.dosage,
                      Instructions: row.instruction,
                      Duration:
                        row.duration +
                        " " +
                        (row.durationIn !== undefined ? row.durationIn : ""),
                      Durations: row.duration,
                      DurationIn:
                        row.durationIn !== undefined ? row.durationIn : "",
                      Quantity: row.quantity,
                      Note: row.note,
                      Route: row?.route,
                      StartDate: row.startDate?.toString(),
                      IvFlowRate: row?.ivFlowRate,
                      id: row.id,
                      drugId: row.drugId,
                      code: row.code,
                      genericdescription: row.genericdescription,
                      drugTapering: row.drugTapering,
                      isParent: row.isParent,
                    }))
                )?.length > 0 ? (
                  <CommonTransactionTable
                    dataResult={mergeMedicationArray(
                      dataMedication
                        .filter((row) => row.isParent === true)
                        .map((row) => ({
                          "Drug Type": row.drugType,
                          "Drug Name": row.drugName,
                          Frequency: row.frequency,
                          Dosage: row.dosage,
                          Instructions: row.instruction,
                          Duration:
                            row.duration +
                            " " +
                            (row.durationIn !== undefined
                              ? row.durationIn
                              : ""),
                          Durations: row.duration,
                          DurationIn:
                            row.durationIn !== undefined ? row.durationIn : "",
                          Quantity: row.quantity,
                          Note: row.note,
                          Route: row?.route,
                          StartDate: row.startDate?.toString(),
                          IvFlowRate: row?.ivFlowRate,
                          id: row.id,
                          drugId: row.drugId,
                          code: row.code,
                          genericdescription: row.genericdescription,
                          drugTapering: row.drugTapering,
                          isParent: row.isParent,
                        }))
                    )}
                    renderActions={renderAction}
                    // renderInput={renderInputs}
                    highlightRow={false}
                    editableColumns={["frequency"]}
                    removeHeaders={[
                      "id",
                      "drugId",
                      "code",
                      "genericdescription",
                      "Drug Type",
                      "Durations",
                      "DurationIn",
                      "drugTapering",
                      "isParent",
                    ]}
                  />
                ) : null}
              </>
            ) : null}
          </div>
          <div>
            {props.edit === false ? (
              <>
                {dataMedication?.length > 0 ? (
                  <>
                    <div className="flex justify-end space-x-2 my-2">
                      <CommonButton
                        type="button"
                        label="Reset"
                        className="resetButton border border-red-500 text-red-500"
                        onClick={() => {
                          setDataMedication([]);
                          setMedicationData([]);
                          setValue("drugTapering", false);
                          setValue("searchDrugMedicine", "");
                          // setValue("quantity", "");
                          setValue("frequency", null);
                          setValue("dosage", "");
                          setValue("quantity", "");
                          setValue("instructions", "");
                          setValue("medicDuration", "");
                          setValue("MedidurationIn", null);
                          setValue("route", null);
                          setValue("ivFlowRate", "");
                          setValue("startDate", new Date());
                          setValue("note", "");
                          setEditData(false);
                        }}
                      />
                      <CommonButton
                        type="button"
                        label="Save"
                        className="saveButton bg-customGreen text-white"
                        onClick={() => {
                          handleSaveMedication();
                        }}
                      />
                    </div>
                  </>
                ) : null}
              </>
            ) : null}
          </div>
          {openDrugTapering === true && (
            <div className="mt-5 space-y-2">
              <div className="font-semibold">
                {selectedDrugTaperingRow?.["Drug Name"]}
              </div>
              {drugTaperingData?.length > 0 &&
              selectedDrugTaperingRow !== null ? (
                <CommonTransactionTable
                  dataResult={drugTaperingData
                    ?.filter(
                      (row) => row.drugId === selectedDrugTaperingRow?.drugId
                    )
                    .map((row) => ({
                      "Drug Type": row.drugType,
                      "Drug Name": row.drugName,
                      Frequency: row.frequency,
                      Dosage: row.dosage,
                      Instructions: row.instruction,
                      Duration:
                        row.duration +
                        " " +
                        (row.durationIn !== undefined ? row.durationIn : ""),
                      Durations: row.duration,
                      DurationIn:
                        row.durationIn !== undefined ? row.durationIn : "",
                      Quantity: row.quantity,
                      Note: row.note,
                      Route: row?.route,
                      StartDate: row.startDate,
                      IvFlowRate: row?.ivFlowRate,
                      id: row.id,
                      drugId: row.drugId,
                      code: row.code,
                      genericdescription: row.genericdescription,
                      drugTapering: row.drugTapering,
                      isParent: false,
                    }))}
                  renderActions={renderActionDrugTapering}
                  removeHeaders={[
                    "id",
                    "drugId",
                    "code",
                    "genericdescription",
                    "Drug Type",
                    "Durations",
                    "DurationIn",
                    "drugTapering",
                    "frequencyList",
                    "dosageList",
                    "instructionList",
                    "durationList",
                    "startDateList",
                    "ivFlowRate",
                    "isParent",
                  ]}
                />
              ) : (
                <div>No Records Found...</div>
              )}
            </div>
          )}

          {/* </form> */}
        </Box>
      </Modal>
      {/* <DrugTaperingModal
        open={openDrugTapering}
        setOpen={setOpenDrugTapering}
        drugTaperingData={drugTaperingData}
        selectedDrugTaperingRow={selectedDrugTaperingRow}
        setOpenMedicationModal={setOpenMedicationModal}
        setEditData={setEditData}
        setRow={setRow}
        setDrugTaperingIndex={setDrugTaperingIndex}
        setDrugTaperingData={setDrugTaperingData}
        setDrugTaperingDuration={setDrugTaperingDuration}
      /> */}
      <ConfirmationModal
        confirmationOpen={openPost}
        confirmationHandleClose={() => {
          setOpenPost(false);
        }}
        confirmationSubmitFunc={() => {
          handleCloseModel();
        }}
        confirmationLabel="Confirmation "
        confirmationMsg="Added Data Not Saved Do You Still Want to Close ?"
        confirmationButtonMsg="Yes"
      />
    </div>
  );
}

